var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 60,
    viewBox: "0 0 96 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8068 25.1818H72.1705C70.7646 25.1818 69.625 26.3215 69.625 27.7273V40.3864C69.625 41.7922 70.7646 42.9318 72.1705 42.9318H91.8068C93.2126 42.9318 94.3523 41.7922 94.3523 40.3864V27.7273C94.3523 26.3215 93.2126 25.1818 91.8068 25.1818Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4203 24.5455V19.6136C89.4203 15.5 86.1021 12.1818 81.9885 12.1818C77.8748 12.1818 74.5566 15.5 74.5566 19.6136V24.8636",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9883 34.6818V38.5",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9883 34.2273C83.2309 34.2273 84.2383 33.2199 84.2383 31.9773C84.2383 30.7347 83.2309 29.7273 81.9883 29.7273C80.7456 29.7273 79.7383 30.7347 79.7383 31.9773C79.7383 33.2199 80.7456 34.2273 81.9883 34.2273Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8757 30C49.8757 16.8205 39.1916 6.13635 26.0121 6.13635C12.8326 6.13635 2.14844 16.8205 2.14844 30C2.14844 43.1795 12.8326 53.8636 26.0121 53.8636C39.1916 53.8636 49.8757 43.1795 49.8757 30Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1257 6.29544C31.0121 6.20453 31.9212 6.13635 32.8303 6.13635C33.853 6.13635 34.8757 6.20453 35.8757 6.31817C47.6257 7.81817 56.6939 17.8409 56.6939 30C56.6939 42.1591 47.603 52.1818 35.853 53.6818C34.853 53.7954 33.853 53.8636 32.8303 53.8636C31.7621 53.8636 30.6939 53.7954 29.6484 53.6591",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3074 6.29544C37.1937 6.20453 38.1028 6.13635 39.0119 6.13635C40.0346 6.13635 41.0574 6.20453 42.0574 6.31817C53.8074 7.81817 62.8755 17.8409 62.8755 30C62.8755 42.1591 53.7846 52.1818 42.0346 53.6818C41.0346 53.7954 40.0346 53.8636 39.0119 53.8636C37.9437 53.8636 36.8755 53.7954 35.8301 53.6591",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2385 34.3636C30.3932 34.3636 33.7613 30.9956 33.7613 26.8409C33.7613 22.6862 30.3932 19.3182 26.2385 19.3182C22.0839 19.3182 18.7158 22.6862 18.7158 26.8409C18.7158 30.9956 22.0839 34.3636 26.2385 34.3636Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2387 50.7046C36.2387 45.0682 31.6705 40.4773 26.0115 40.4773C20.3524 40.4773 15.7842 45.0455 15.7842 50.7046",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRp);
export default __webpack_public_path__ + "static/media/RP.741b0d852502ae64551ffc4b20d41d3a.svg";
export { ForwardRef as ReactComponent };